import { Navigate } from 'react-router-dom'
import { useProgramContext } from '@/context/ProgramContext'
import { canManageWidgets } from '@/lib/programPermissions'

export function WidgetsGuard({ children }: { children: React.ReactNode }) {
	const { currentProgramAccessLevel } = useProgramContext()

	if (!canManageWidgets(currentProgramAccessLevel)) {
		return <Navigate to="/dashboard" replace />
	}

	return <>{children}</>
}
